import { ApiResponse, PaginatedResponse } from '@/domain';
import { Parcel, ParcelFilters, ParcelContractDetail } from '@/domain/parcels/parcel';
import { backendApi } from '../backendApi';

export const parcelsApi = {
  getParcels: (filters?: ParcelFilters) =>
    backendApi.get<ApiResponse<PaginatedResponse<Parcel>>>('/api/v1/data/parcels', {
      params: filters,
    }).then((res) => res.data.data),

  getParcel: (id: string) =>
    backendApi.get<ApiResponse<Parcel>>(`/api/v1/data/parcels/${id}`).then((res) => res.data.data),

  getParcelByContract: (contractId: string) =>
    backendApi.get<ApiResponse<Parcel>>(`/api/v1/data/agreements/${contractId}/parcel`).then((res) => res.data.data),

  updateParcel: (id: string, data: Partial<Parcel>) =>
    backendApi.put<ApiResponse<Parcel>>(`/api/v1/data/parcels/${id}`, data).then((res) => res.data.data),

  updateParcelStatus: (id: string, state: string) =>
    backendApi.patch<ApiResponse<Parcel>>(`/api/v1/data/parcels/${id}/status`, { state }).then((res) => res.data.data),

  getParcelContractDetail: (contractId: string, parcelId: string) =>
    backendApi.get<ApiResponse<ParcelContractDetail>>(`/api/v1/data/agreements/${contractId}/parcel/${parcelId}`).then((res) => res.data.data),

  createNewEvent: (contractId: string, parcelId: string, data: any) =>
    backendApi.post<ApiResponse<any>>(`/api/v1/data/agreements/${contractId}/parcel/${parcelId}/events`, data).then((res) => res.data.data),

  deleteParcelContractEvent: (contractId: string, parcelId: string, eventId: string) =>
    backendApi.delete<ApiResponse<any>>(`/api/v1/data/agreements/${contractId}/parcel/${parcelId}/events/${eventId}`).then((res) => res.data.data),
};
